import { AxiosRequestConfig, AxiosRequestHeaders, Method } from 'axios';
import json from '../../package.json';
import { API_URL } from "./api";
import axiosInstance from "./axiosInstance";

export const METHODS = {
    GET: 'GET' as const,
    POST: 'POST' as const,
    PUT: 'PUT' as const,
    DELETE: 'DELETE' as const,
    PATCH: 'PATCH' as const,
};

const getHeaders = (isJson: boolean) => {
    const headers: AxiosRequestConfig["headers"] = {
        // "Cookie": document.cookie,
        "X-CLIENT-VER": json.version,
    };
    if (isJson) {
        headers['Content-Type'] = 'application/json; charset=UTF-8';
    }
    return headers;
}


interface ICheckStatus<T extends ICheckStatusData> {
    status: number;
    data: T;
    headers: AxiosRequestHeaders;
    config: AxiosRequestConfig;
}

type ICheckStatusData = {
    status: string;
    statusText: string | undefined;
    error: { message: string | undefined; };
}

export const checkStatus = <T extends ICheckStatusData>(response: ICheckStatus<T>): T => {
    if (response && response.status >= 200 && response.status < 300) {
        if (response.data.status === 'fail') {
            const error = new Error(response.data.statusText);
            //@ts-ignore
            error.response = response;
            throw error;
        }
        return response.data;
    }
    const error = new Error(response.data.error.message);
    //@ts-ignore
    error.response = response;
    throw error;
}

interface IcheckReject {
    response: {
        data: {
            error: { message: string; };
            message: string;
        };
    };
}

export function checkReject(failed: IcheckReject) {
    const error = Error(failed.response?.data?.error?.message || failed.response?.data?.message);
    //@ts-ignore
    error.response = failed.response;
    throw error;
}


const request = (url: string, method: Method, optionsInit: AxiosRequestConfig = {}) => {
    const options = Object.assign({}, optionsInit);
    options.headers = getHeaders(true);

    //@ts-ignore
    options.credentials = 'include';

    return axiosInstance({
        url: API_URL + url,
        method,
        ...options,
    })
        .catch(checkReject)
        //@ts-ignore
        .then(checkStatus);
};

export const getRequest = (url: string, params: AxiosRequestConfig["params"] = {}, options: AxiosRequestConfig = {}) =>
    request(url, METHODS.GET, { params, ...options });

export const postRequest = (url: string, body?: AxiosRequestConfig["data"], params: AxiosRequestConfig["params"] = {}, options: AxiosRequestConfig = {}) =>
    request(url, METHODS.POST, { data: body, params, ...options });

export const putRequest = (url: string, body?: AxiosRequestConfig["data"], params: AxiosRequestConfig["params"] = {}, options: AxiosRequestConfig = {}) =>
    request(url, METHODS.PUT, { data: body, params, ...options });

export const deleteRequest = (url: string, body?: AxiosRequestConfig["data"], params: AxiosRequestConfig["params"] = {}, options: AxiosRequestConfig = {}) =>
    request(url, METHODS.DELETE, { data: body, params, ...options });
